import { render, staticRenderFns } from "./StageHistoryByCitation.vue?vue&type=template&id=494e25e2"
import script from "./StageHistoryByCitation.vue?vue&type=script&lang=js"
export * from "./StageHistoryByCitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports